/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [],
        name: "AccessControlBadConfirmation",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        name: "AccessControlEnforcedDefaultAdminDelay",
        type: "error",
    },
    {
        inputs: [],
        name: "AccessControlEnforcedDefaultAdminRules",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "defaultAdmin",
                type: "address",
            },
        ],
        name: "AccessControlInvalidDefaultAdmin",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "neededRole",
                type: "bytes32",
            },
        ],
        name: "AccessControlUnauthorizedAccount",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
        ],
        name: "AddressEmptyCode",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "ERC1967InvalidImplementation",
        type: "error",
    },
    {
        inputs: [],
        name: "ERC1967NonPayable",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "allowance",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "needed",
                type: "uint256",
            },
        ],
        name: "ERC20InsufficientAllowance",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "needed",
                type: "uint256",
            },
        ],
        name: "ERC20InsufficientBalance",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "approver",
                type: "address",
            },
        ],
        name: "ERC20InvalidApprover",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
        ],
        name: "ERC20InvalidReceiver",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "ERC20InvalidSender",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "ERC20InvalidSpender",
        type: "error",
    },
    {
        inputs: [],
        name: "EnforcedPause",
        type: "error",
    },
    {
        inputs: [],
        name: "ExpectedPause",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedCall",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "contractAddress",
                type: "address",
            },
        ],
        name: "InvalidContractAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidInitialization",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "InvalidRoleAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "NotInitializing",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "caller",
                type: "address",
            },
        ],
        name: "OnlyTrinityPool",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "value",
                type: "int256",
            },
        ],
        name: "SafeCastOverflowedIntToUint",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "bits",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "SafeCastOverflowedUintDowncast",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "SafeCastOverflowedUintToInt",
        type: "error",
    },
    {
        inputs: [],
        name: "UUPSUnauthorizedCallContext",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "slot",
                type: "bytes32",
            },
        ],
        name: "UUPSUnsupportedProxiableUUID",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DefaultAdminDelayChangeCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
            {
                indexed: false,
                internalType: "uint48",
                name: "effectSchedule",
                type: "uint48",
            },
        ],
        name: "DefaultAdminDelayChangeScheduled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DefaultAdminTransferCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint48",
                name: "acceptSchedule",
                type: "uint48",
            },
        ],
        name: "DefaultAdminTransferScheduled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint64",
                name: "version",
                type: "uint64",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "NewImplementation",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32",
            },
        ],
        name: "RoleAdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleRevoked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPGRADE_INTERFACE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "acceptDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "beginDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "burnFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "cancelDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
        ],
        name: "changeDefaultAdminDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "totalSupply_",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "isSupplyPassed",
                type: "bool",
            },
        ],
        name: "convertToAssets",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256",
            },
        ],
        name: "convertToShares",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdminDelay",
        outputs: [
            {
                internalType: "uint48",
                name: "",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdminDelayIncreaseWait",
        outputs: [
            {
                internalType: "uint48",
                name: "",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getInterestYield",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "initialOwner_",
                type: "address",
            },
            {
                internalType: "address",
                name: "trinityPool_",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingDefaultAdmin",
        outputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingDefaultAdminDelay",
        outputs: [
            {
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "rollbackDefaultAdminDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "sharesOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalShares",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class MUnity__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
MUnity__factory.bytecode = _bytecode;
MUnity__factory.abi = _abi;
//# sourceMappingURL=MUnity__factory.js.map